// extracted by mini-css-extract-plugin
export var cardIcon = "_7n-4";
export var checkboxCard = "_7n-0";
export var checkboxCardSelected = "_7n-3";
export var disabled = "_7n-1";
export var outerBorder = "_7n-2";
export var spacerMedium = "_7n-7";
export var spacerSmall = "_7n-6";
export var spacerXsmall = "_7n-5";